export default "__VITE_ASSET__$FIBbQIc__"